import { render, staticRenderFns } from "./PayStatistical.vue?vue&type=template&id=5dff9fd2&scoped=true&"
import script from "./PayStatistical.vue?vue&type=script&lang=js&"
export * from "./PayStatistical.vue?vue&type=script&lang=js&"
import style0 from "./PayStatistical.vue?vue&type=style&index=0&id=5dff9fd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dff9fd2",
  null
  
)

export default component.exports